import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-migration-tool-admin',
  templateUrl: './cloud-migration-tool-admin.component.html',
  styleUrls: ['./cloud-migration-tool-admin.component.scss']
})
export class CloudMigrationToolAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
